import firebase from 'firebase/app'
import 'firebase/database'
import firebaseConfig from './firebase-config'
import { ensureFirebaseAuth } from '@/plugins/firebase/auth'
import packageInfo from '../../package.json'

console.info('version:', packageInfo.version)
const env = process.env.NODE_ENV
const server = {}
// server.backendUrl = 'http://35.239.248.141:41499/api' // fetch tripod
server.backendUrl = process.env.BACKEND_URL
server.viewerUrl = process.env.VIEWER_URL
server.tourringUrl = process.env.TOURRING_URL
server.mixpanelToken = process.env.MIXPANEL_TOKEN
server.loungeUrl = process.env.LOUNGE_URL
server.socketUrl = process.env.SOCKET_URL

server.prodServers = ['prod']

firebase.initializeApp(firebaseConfig)
ensureFirebaseAuth().catch(error => {
  console.error('[Firebase] Initial anonymous sign-in failed. Firebase requests will retry on demand.', error)
})

if (process.env.USE_GOOGLE_MAP) {
  server.googleApiKey = process.env.GOOGLE_API_KEY
}

server.talkjsAppId = process.env.TALKJS_APP_ID
server.gaId = process.env.GA_ID
server.ga4Id = process.env.GA4_ID

for (const item in process.env) {
  console.log(`${item}:`, process.env[item])
}

switch (env) {
  case 'dev':
    server.firebaseStorageUrlStart = 'https://vrmaker-dev.istaging.com/'
    break
  case 'test':
    server.firebaseStorageUrlStart = 'https://vrcam-test-cdn.istaging.com/'
    break
  case 'prod':
    server.firebaseStorageUrlStart = 'https://vrmaker.istaging.com/'
    break
  default:
}

server.facebookAppId = '956126194495663'

export default server
